import React, { useCallback, useMemo } from 'react'
import { usePanelPatientUid } from '../../dashboard/panelContext'
import { CardFooter, FieldRow, FieldSection, LabeledSelect, LabeledText } from '../fieldPrimitives'
import { OCCUPATION_OPTIONS } from './patientRecordOptions'
import { OCCUPATION_SCHEMA } from './patientRecordSchema'
import { makeFieldSetter, useCardAutosave } from './useCardAutosave'
import { usePatientRecord } from './usePatientRecord'
import { useUpdatePatientRecord } from './useUpdatePatientRecord'

type OccupationValues = { occupation: string; employer: string }

const OccupationPanel = () => {
  const uid = usePanelPatientUid()
  const { loading, patient, details } = usePatientRecord(uid)
  const update = useUpdatePatientRecord(uid)

  const initial = useMemo<OccupationValues>(
    () => ({ occupation: patient?.occupation ?? '', employer: details.employer ?? '' }),
    [patient?.occupation, details.employer]
  )

  const save = useCallback(
    (next: OccupationValues) => update({ occupation: next.occupation }, { employer: next.employer }),
    [update]
  )

  const { values, setValues, error, status } = useCardAutosave(initial, OCCUPATION_SCHEMA, save)
  const set = makeFieldSetter(setValues)

  return (
    <FieldSection>
      <FieldRow columns={2}>
        <LabeledSelect
          label="Occupation"
          value={values.occupation}
          onChange={set('occupation')}
          options={OCCUPATION_OPTIONS}
        />
        <LabeledText label="Participating employer" value={values.employer} onChange={set('employer')} />
      </FieldRow>
      <CardFooter loading={loading} status={status} error={error} />
    </FieldSection>
  )
}

export default OccupationPanel
